import axios from 'axios';
import configs from '@/common/config';
export default {
  loadAssets: async () => {
    // list all assets  we have to load
    try {
      const response = await axios.get(`/assets`);
      let { data } = response;

      for (let asset of data) {
        try {
          //console.log('pre-load', `/assets/${asset}`);
          axios.get(`/assets/${asset}`);
        } catch (err) {
          console.warn(`failed to load ${asset}. ignoring`);
        }
      }
    } catch (err) {
      console.error('Failed loading all necessary assets', err);
    }
  },
};
